import { ChevronLeft } from '@styled-icons/heroicons-outline/ChevronLeft';
import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { ScrollButtonGroupSchema } from '@/views/sports/components/ScrollButtonGroup/styles/ScrollButtonGroup.styles';

export const scrollButtonGroupStyles: ScrollButtonGroupSchema = {
  iconButtonScrollRightSvg: {
    as: ChevronRight,
    sx: {
      boxSize: '3.5',
    },
  },
  iconButtonScrollRight: {
    bgGradient: 'linear(to-b, alpha.400, alpha.500)',
    color: 'beta.600',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    border: 'none',
    h: 9,
    w: 4,
    boxShadow:
      '0px 0px 0px 1px rgba(255, 255, 255, 0.3) inset, 0px 3px 5px 0px rgba(0, 0, 0, 0.3)',
    _hover: {
      color: 'beta.600',
    },
    _active: {
      '&:after': {
        backgroundImage: 'none',
      },
    },
  },
  iconButtonScrollLeftSvg: {
    as: ChevronLeft,
    sx: {
      boxSize: '3.5',
    },
  },
  iconButtonScrollLeft: {
    bgGradient: 'linear(to-b, alpha.400, alpha.500)',
    border: 'none',
    color: 'beta.600',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    h: 9,
    w: 4,
    boxShadow:
      '0px 0px 0px 1px rgba(255, 255, 255, 0.3) inset, 0px 3px 5px 0px rgba(0, 0, 0, 0.3)',
    _hover: {
      color: 'beta.600',
    },
    _active: {
      '&:after': {
        backgroundImage: 'none',
      },
    },
  },
  flexWrapper: {
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 3px 5px 0px rgba(0, 0, 0, 0.20) inset',
  },
  buttonGroupSports: {
    bg: 'beta.700',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
    borderRadius: [null, null, 'base'],
    display: 'inline-flex',
    flex: '1',
    overflowX: 'auto',
    pl: '1',
    py: '1',
    spacing: '1',
    whiteSpace: 'nowrap',
    sx: { '::-webkit-scrollbar': { display: 'none' } },
  },
  buttonGroupScrolls: {
    display: ['none', null, null, 'inline-flex'],
    pos: 'relative',
    ml: 'auto',
    gap: 1,
    pl: 1,
    pt: 0.5,
    isAttached: true,
  },
  scrollIndicator: {
    pos: 'absolute',
  },
};
